export default __webpack_public_path__ + "static/media/filterUncheckedIcon.617472d2.svg";